import { useEffect, useState } from "react";

export default function useIsTouchDevice(): boolean {
  const [isTouchDevice, setIsTouchDevice] = useState(false);

  useEffect(() => {
    const updateTouchStatus = () => {
      const touchCapable =
        "ontouchstart" in window ||
        navigator.maxTouchPoints > 0 ||
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (navigator as any).msMaxTouchPoints > 0;
      setIsTouchDevice(touchCapable);
    };

    updateTouchStatus();

    // Optionally listen for changes in the environment
    window.addEventListener("resize", updateTouchStatus);

    return () => {
      window.removeEventListener("resize", updateTouchStatus);
    };
  }, []);

  return isTouchDevice;
}
